module.exports = __webpack_public_path__ + "img/forward-item-1.8177bec6.svg";